import React from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export default function SignatorySelect({ signatories, value, onChange }) {
  if (!signatories.length) {
    return (
      <div className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-sm p-2" data-testid="esign-no-signatory">
        No active authorised signatory. Add or activate one under Settings → eSign Signatories.
      </div>
    );
  }
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="rounded-sm" data-testid="esign-signatory-select">
        <SelectValue placeholder="Choose authorised signatory" />
      </SelectTrigger>
      <SelectContent>
        {signatories.map((s) => (
          <SelectItem key={s.id} value={s.id} data-testid={`esign-signatory-option-${s.id}`}>
            {s.name}{s.designation ? ` · ${s.designation}` : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
